// Registrierung des Service Workers aus public/service-worker.js.
//
// Ersetzt das Boilerplate aus Create React App 3. Dessen register() nahm zwar
// ein Argument entgegen, benutzte es aber nie als URL, sondern suchte immer
// `${PUBLIC_URL}/service-worker.js` — eine Datei, die react-scripts 5 ohne die
// workbox-Pakete gar nicht erzeugt. Die Registrierung lief dadurch ins Leere.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export { isLocalhost };

export function register(swUrl = `${process.env.PUBLIC_URL}/service-worker.js`) {
  // Im Dev-Server würde ein aktiver Service Worker das Hot Reloading stören.
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  // Bei abweichender Origin (etwa CDN) greift der Service Worker nicht.
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (installing == null) {
            return;
          }
          installing.onstatechange = () => {
            if (installing.state !== 'installed') {
              return;
            }
            if (navigator.serviceWorker.controller) {
              console.log('Neue Inhalte verfügbar, sie greifen nach dem nächsten Laden.');
            } else {
              console.log('Inhalte für die Offline-Nutzung zwischengespeichert.');
            }
          };
        };
      })
      .catch((error) => {
        console.error('Service Worker konnte nicht registriert werden:', error);
      });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker.ready
    .then((registration) => {
      registration.unregister();
    })
    .catch((error) => {
      console.error(error.message);
    });
}
